 enum RouteNamesEnum {
    HOME = "/",
    GALERY ="/gallery",
    ABOUT ="/#about",
    ORDER ="/order",
    EXHIBITIONS ="/exhibitions",
    DETAILED_EXHIBITION_PAGE ="/exhibitions/detail",
    TAMARA_DEMENTJEVA="/tamara_dementjeva"
  }

  export default RouteNamesEnum;